import { render, staticRenderFns } from "./cryptoDetails.vue?vue&type=template&id=296e68dc&scoped=true"
import script from "./cryptoDetails.vue?vue&type=script&lang=js"
export * from "./cryptoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e68dc",
  null
  
)

export default component.exports